import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import {
  DollarSign,
  Clock,
  Shield,
  Heart,
  Star,
  CheckCircle2,
  Camera,
  FileCheck,
  Headphones,
} from "lucide-react";

export default function HostsLanding() {
  const goToHostSignup = () => {
    const isLoggedIn = !!window.__AUTH_ID__;

    if (isLoggedIn) {
      window.location.href = "/solicitacao-anfitriao";
      return;
    }

    window.location.href = "/register?next=/solicitacao-anfitriao";
  };

  return (
    <div className="min-h-screen bg-background">
      <Header activeTab="anfitrioes" />

      <section className="relative overflow-hidden py-12 md:py-20 lg:py-32">
        <div className="absolute inset-0 bg-gradient-to-br from-[hsl(var(--forest))] to-[hsl(var(--forest-dark))]" />
        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 md:mb-6 leading-tight">
              Transforme seu amor por pets em renda extra
            </h1>

            <p className="text-base sm:text-lg md:text-2xl mb-8 md:mb-10 text-white/90 leading-relaxed">
              Seja um anfitrião AllePets e ganhe dinheiro cuidando de pets enquanto seus tutores viajam.
            </p>

            <Button
              size="lg"
              onClick={goToHostSignup}
              className="w-full sm:w-auto bg-coral hover:bg-coral-dark text-white font-bold text-base md:text-lg px-6 md:px-10 py-5 md:py-7 rounded-full"
            >
              Começar cadastro
            </Button>

            <p className="text-sm text-white/70 mt-4">Cadastro gratuito</p>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-12 bg-muted">
        <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-2xl md:text-4xl font-bold text-forest">R$ 3.000</div>
              <p className="text-sm md:text-base text-muted-foreground">
                Ganho médio/mês (valor variável conforme atividade)
              </p>
            </div>

            <div>
              <div className="text-2xl md:text-4xl font-bold text-forest">10.000+</div>
              <p className="text-sm md:text-base text-muted-foreground">
                Anfitriões ativos (estimativa Brasil)
              </p>
            </div>

            <div>
              <div className="text-2xl md:text-4xl font-bold text-forest">4.8</div>
              <p className="text-sm md:text-base text-muted-foreground">
                Avaliação média
              </p>
            </div>

            <div>
              <div className="text-2xl md:text-4xl font-bold text-forest">50.000+</div>
              <p className="text-sm md:text-base text-muted-foreground">
                Estadias realizadas (estimativa Brasil)
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-12">
            Como funciona
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-forest-light mx-auto mb-5 md:mb-6 flex items-center justify-center">
                <FileCheck className="w-8 h-8 md:w-10 md:h-10 text-forest" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-coral mb-3">1</div>
              <h3 className="text-lg md:text-xl font-bold mb-3">Crie seu perfil</h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                Cadastre-se gratuitamente, adicione fotos do seu espaço e defina seus serviços e preços.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-forest-light mx-auto mb-5 md:mb-6 flex items-center justify-center">
                <Camera className="w-8 h-8 md:w-10 md:h-10 text-forest" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-coral mb-3">2</div>
              <h3 className="text-lg md:text-xl font-bold mb-3">Receba reservas</h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                Tutores encontram seu perfil e solicitam reservas. Você decide quais aceitar.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-forest-light mx-auto mb-5 md:mb-6 flex items-center justify-center">
                <DollarSign className="w-8 h-8 md:w-10 md:h-10 text-forest" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-coral mb-3">3</div>
              <h3 className="text-lg md:text-xl font-bold mb-3">Ganhe dinheiro</h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                Cuide dos pets e receba seu pagamento de forma segura após cada estadia.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-muted">
        <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-12">
            Por que ser um anfitrião?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
            {[
              {
                icon: DollarSign,
                title: "Renda extra",
                description: "Ganhe até R$ 3.000/mês fazendo o que você ama.",
              },
              {
                icon: Clock,
                title: "Horários flexíveis",
                description: "Você define quando e quantos pets pode receber.",
              },
              {
                icon: Shield,
                title: "Seguro incluso",
                description: "Cobertura veterinária para imprevistos durante a estadia.",
              },
              {
                icon: Heart,
                title: "Faça amigos",
                description: "Conheça pets incríveis e seus tutores.",
              },
            ].map(({ icon: Icon, title, description }, i) => (
              <div
                key={i}
                className="bg-background rounded-xl p-5 md:p-6 text-center shadow-sm"
              >
                <div className="w-14 h-14 rounded-full bg-coral/10 mx-auto mb-4 flex items-center justify-center">
                  <Icon className="w-7 h-7 text-coral" />
                </div>
                <h3 className="font-bold text-lg mb-2">{title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-12">
            Requisitos básicos
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              "Ser maior de 18 anos",
              "Ter espaço seguro para receber pets",
              "Amar e ter experiência com animais",
              "Disponibilidade para cuidar com atenção",
              "Não ter mais de 4 pets próprios",
              "Concordar com nossas políticas de segurança",
            ].map((req, i) => (
              <div
                key={i}
                className="flex items-start gap-3 p-4 bg-muted rounded-xl"
              >
                <CheckCircle2 className="w-6 h-6 text-forest flex-shrink-0 mt-0.5" />
                <span className="font-medium text-sm md:text-base leading-relaxed">
                  {req}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-forest text-white">
        <div className="w-full max-w-[1100px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-12">
            Segurança e suporte
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <Shield className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-4" />
              <h3 className="font-bold text-lg md:text-xl mb-2">
                Seguro veterinário
              </h3>
              <p className="text-sm md:text-base text-white/80 leading-relaxed">
                Cobertura de até R$ 5.000 em emergências veterinárias durante a estadia.
              </p>
            </div>

            <div className="text-center">
              <Headphones className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-4" />
              <h3 className="font-bold text-lg md:text-xl mb-2">Suporte 24h</h3>
              <p className="text-sm md:text-base text-white/80 leading-relaxed">
                Nossa equipe está sempre disponível para ajudar você e os tutores.
              </p>
            </div>

            <div className="text-center">
              <Star className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-4" />
              <h3 className="font-bold text-lg md:text-xl mb-2">Treinamentos</h3>
              <p className="text-sm md:text-base text-white/80 leading-relaxed">
                Acesso a conteúdos exclusivos sobre cuidados com pets.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-12">
            O que dizem nossos anfitriões
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
            {[
              {
                name: "Mariana S.",
                location: "São Paulo, SP",
                text: "Ser anfitriã AllePets mudou minha vida! Ganho uma renda extra fazendo o que amo e ainda faço amigos peludos incríveis.",
                earnings: "R$ 2.800/mês",
              },
              {
                name: "Rafael L.",
                location: "Rio de Janeiro, RJ",
                text: "Trabalho de casa e a flexibilidade é perfeita. Posso escolher quando recebo pets e quanto quero ganhar.",
                earnings: "R$ 3.200/mês",
              },
              {
                name: "Patricia M.",
                location: "Belo Horizonte, MG",
                text: "O suporte da AllePets é incrível. Sempre que preciso de ajuda, eles respondem rapidamente.",
                earnings: "R$ 2.500/mês",
              },
            ].map((testimonial, i) => (
              <div key={i} className="bg-muted rounded-xl p-5 md:p-6">
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star
                      key={j}
                      className="w-4 h-4 fill-forest text-forest"
                    />
                  ))}
                </div>

                <p className="text-foreground mb-4 text-sm md:text-base leading-relaxed">
                  "{testimonial.text}"
                </p>

                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <div>
                    <p className="font-semibold">{testimonial.name}</p>
                    <p className="text-sm text-muted-foreground">
                      {testimonial.location}
                    </p>
                  </div>

                  <div className="text-left sm:text-right">
                    <p className="text-sm text-muted-foreground">
                      Ganha em média
                    </p>
                    <p className="font-bold text-forest">
                      {testimonial.earnings}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-gradient-to-br from-[hsl(var(--coral))] to-[hsl(var(--coral-dark))] text-white">
        <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6">
            Pronto para começar?
          </h2>

          <p className="text-base md:text-xl mb-8 md:mb-10 text-white/90 max-w-2xl mx-auto leading-relaxed">
            Junte-se a milhares de anfitriões que já transformaram sua paixão por pets em renda.
          </p>

          <Button
            size="lg"
            onClick={goToHostSignup}
            className="w-full sm:w-auto bg-white text-[hsl(var(--coral))] hover:bg-white/90 font-bold text-base md:text-lg px-6 md:px-10 py-5 md:py-7 rounded-full"
          >
            Criar meu perfil de anfitrião
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}